import React from "react";
import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";
import { IGongBallHistoryType } from "@/types/GameHistoryTypes";
import { getATValue } from "@/modules/commonPopupResultHistory";

//note: use this.props.langdata to get language information
export default class M16 extends IGameStatisticsClass {
	constructor() {
		super(null);

		this.filtrate = function(history: IGongBallHistoryType[], filter) {
			const total = history.length;
			
			switch (filter) {
				case "player-banker": 
					let players = 0, bankers = 0;
					history.forEach(item => {
						if (item.result === "Player")
							players++;
						else if (item.result === "Banker")
							bankers++;
					});
					
					this.statisticsArray.top.push([
						<div key="m16gst_0" className="sl-roadmap-circle blue-bg">P</div>,
						<div key="m16gst_1" className="sl-roadmap-circle red-bg">B</div>
					]);
					
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("m16gsb_0", players, total),
						processStatisticsPercentage("m16gsb_1", bankers, total)
					]);
				break;

				case "odd-even":
					let odds = 0, evens = 0;
					history.forEach(item => {
						const totalAngka = (
								item.result === "Banker" ?
								item.angka1 : item.angka2
							).split(",")
							.map(num => getATValue(num))
							.reduce((a, b) => a + b) % 10;

						if (totalAngka % 2)
							odds++;
						else evens++;
					});
					
					this.statisticsArray.top.push([
						<div key="m16gst_2" className="sl-roadmap-circle blue-bg">O</div>,
						<div key="m16gst_3" className="sl-roadmap-circle red-bg">E</div>
					]);
					
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("m16gsb_2", odds, total),
						processStatisticsPercentage("m16gsb_3", evens, total)
					]);
				break;
				case "small-big":
					let smalls = 0, bigs = 0;
					history.forEach(item => {
						const totalAngka = (
								item.result === "Banker" ?
								item.angka1 :
								item.angka2
							).split(",")
							.map(num => getATValue(num))
							.reduce((a, b) => a + b) % 10;

						if (totalAngka <= 5)
							smalls++;
						else bigs++;
					});
	
					this.statisticsArray.top.push([
						<div key="m16gst_4" className="sl-roadmap-circle blue-circle">S</div>,
						<div key="m16gst_5" className="sl-roadmap-circle red-circle">B</div>
					]);
	
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("m16gsb_4", smalls, total),
						processStatisticsPercentage("m16gsb_5", bigs, total)
					]);
				break;
				default: break;
			}
		};
	}

	render() {
		return renderStatistics(this);
	}
}
